import { defineMessages } from 'react-intl';

/** User-facing copy for ``VisualDxGallery``. */
export const visualDxGalleryMessages = defineMessages({
  groupAll: {
    id: 'V/5mxdVF6U',
    defaultMessage: 'All skin tones',
    description: 'Filter chip that shows every image regardless of skin tone',
  },
  groupLight: {
    id: 'ikqQnQ0g6g',
    defaultMessage: 'Light I–II',
    description: 'Filter chip for Fitzpatrick skin types 1 and 2',
  },
  groupMedium: {
    id: 'RlZa/uuT/8',
    defaultMessage: 'Medium III–IV',
    description: 'Filter chip for Fitzpatrick skin types 3 and 4',
  },
  groupDark: {
    id: '3OYBmDwMnH',
    defaultMessage: 'Dark V–VI',
    description: 'Filter chip for Fitzpatrick skin types 5 and 6',
  },
  filterLabel: {
    id: 'yJwiw24dMy',
    defaultMessage: 'Filter by skin tone',
    description: 'Accessible label for the skin-tone filter chip group',
  },
  emptyForDiagnosis: {
    id: 'yHfmbE6M09',
    defaultMessage: 'No VisualDx images available for {diagnosis}.',
    description: 'Empty state when the gallery has no images for the named diagnosis',
  },
  empty: {
    id: 'Ba/aU7MHyN',
    defaultMessage: 'No VisualDx images available.',
    description: 'Empty state when the gallery has no images and no diagnosis name',
  },
  openInVisualDx: {
    id: 'ocUDPtANWk',
    defaultMessage: 'Open in VisualDx',
    description: 'Link out to VisualDx from the empty gallery state',
  },
  heading: {
    id: 'uBGMo9X6MS',
    defaultMessage: 'Image gallery',
    description: 'Fallback gallery heading when the diagnosis name is unknown',
  },
  imageCount: {
    id: 'Hxyw3sc220',
    defaultMessage: '{count, plural, one {# image} other {# images}}',
    description: 'Total number of images VisualDx has for this diagnosis',
  },
  pageOf: {
    id: 'eI098iMr6A',
    defaultMessage: 'page {page} of {total}',
    description: 'Which page of the gallery is shown',
  },
  skinType: {
    id: 'JquaZvvzvU',
    defaultMessage: 'Skin {type}',
    description: 'Tag on an image tile showing its Fitzpatrick skin type number',
  },
  tileLabelWithCaption: {
    id: 'VncG+jrHCs',
    defaultMessage: '{caption}, open in VisualDx',
    description: 'Accessible label for an image tile that links out to VisualDx',
  },
  tileLabel: {
    id: '2cVw5VQNPs',
    defaultMessage: 'Open image in VisualDx',
    description:
      'Accessible label for an uncaptioned image tile that links out to VisualDx',
  },
  noneForTone: {
    id: 'hb0yt9Fcfx',
    defaultMessage: 'No images tagged for this skin tone on this page.',
    description: 'Shown when a skin-tone filter leaves the grid empty',
  },
  disclaimer: {
    id: '+abM7SGcsd',
    defaultMessage: 'Images © VisualDx. Select a tile to view it full size.',
    description: 'Footer under the gallery grid',
  },
  browseAll: {
    id: 'a2YICsexR6',
    defaultMessage: 'Browse all in VisualDx',
    description: 'Link out to the full gallery in VisualDx',
  },
});
